/**
 * Auxiliary variable declaration for build app in development or production modes.
 */
export const environment = {
	production: true,
	envName: 'prod',
	storeRuntimeChecksEnabled: false,
};
